import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { useState } from "react";

export const BookingModal = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen);
    if (isOpen && !document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]')) {
      const script = document.createElement("script");
      script.src = "https://link.msgsndr.com/js/form_embed.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[800px] w-[95vw] h-[90vh] p-0 overflow-hidden bg-white border-none rounded-xl flex flex-col">
        <div className="bg-slate-50 border-b border-slate-200 p-4 text-center text-sm md:text-base text-slate-700 shrink-0 shadow-sm z-10">
          If you would like an in person appointment please call <a href="tel:1-780-237-6933" className="font-bold text-primary hover:underline">1-780-237-6933</a>, otherwise all appointments will be arranged via Google Meets or Zoom.
        </div>
        <div className="flex-1 overflow-y-auto w-full relative">
          <iframe 
            src="https://api.leadconnectorhq.com/widget/booking/6zqXppC8Hwn44PqNnkVo" 
            style={{ width: "100%", border: "none", minHeight: "800px" }} 
            scrolling="yes" 
            id="6zqXppC8Hwn44PqNnkVo_1781375629304"
            title="Booking Widget"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
